import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const TimeSlotButton = styled.button<{ active?: boolean; soldOut?: boolean }>`
  ${Reset('button')}
  border: 1px solid ${props => props.theme.color.line};
  color: ${props => props.theme.color.global};
  height: 3.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0.7rem;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    opacity 0.2s ease;

  ${props =>
    props.active &&
    css`
      background-color: ${props => props.theme.color.primary};
      border-color: ${props => props.theme.color.primary};
      color: ${props => props.theme.color.inverted};
    `};

  ${props =>
    props.soldOut &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
      pointer-events: none;
    `};
`

export const TimeSlotValue = styled.strong`
  font-size: 1rem;
  line-height: 1.1;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
`

export const TimeSlotFlag = styled.img`
  width: 0.85rem;
  height: 0.85rem;
  display: block;
  flex-shrink: 0;
`

export const TimeSlotAvailability = styled.span`
  font-size: 0.7rem;
  color: currentColor;
  opacity: 0.55;
  line-height: 1.1;
`
